import React from "react"

import OurPeopleDetails from "./OurPeopleDetails"

import * as ourPeopleStyles from "../styles/OurPeople.module.css"

const columnData = subColumnDataNodes => {
  if (!subColumnDataNodes || !subColumnDataNodes.length) return null

  const titleNode = subColumnDataNodes.filter(
    node => node.rawTagName === `h4`
  )[0]
  const title = (titleNode && titleNode.text) || ``

  const subColumnsSummaries = subColumnDataNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes(`our-people-details`)
  )

  let content = null
  if (subColumnsSummaries && subColumnsSummaries.length) {
    content = subColumnsSummaries[0]
  }

  return { title, desc: ``, content }
}

function OurPeople(props) {
  const [openTab, setOpenTab] = React.useState(0)
  const [openSubTab, setOpenSubTab] = React.useState(0)

  const { content } = props

  const tabsNodes = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes(`our-people-wrapper`)
  )

  const headingNode = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("our-people-heading")
  )[0]
  const heading = (headingNode && headingNode.text) || ``

  const tabs = tabsNodes.map(node => {
    const children = node.childNodes
    if (!children || !children.length) return { title: ``, desc: ``, cols: [] }

    const titleNode = children.filter(node => node.rawTagName === `h3`)[0]
    const title = (titleNode && titleNode.text) || ``

    const subColumnsNodes = children.filter(
      node =>
        node.classNames
          .trim()
          .split(/\s+/)
          .includes("three-tabbed-data-subcolumn") && node.rawTagName !== `h3`
    )
    if (!subColumnsNodes || !subColumnsNodes.length)
      return { title: title, desc: ``, cols: [] }

    let cols = []
    subColumnsNodes.forEach(node => {
      const currentSubColumn = columnData(node.childNodes)
      if (currentSubColumn) cols.push(currentSubColumn)
    })

    return { title, desc: ``, cols }
  })

  console.log(content)

  return (
    <div id="global-locations" className={`row ${ourPeopleStyles.wrapper}`}>
      <div className={`col-12 ${ourPeopleStyles.introWrapper}`}>
        <div className={`row ${ourPeopleStyles.intro}`}>
          <div className={`col-12 ${ourPeopleStyles.title}`}>
            <h2>{heading}</h2>
          </div>
        </div>

        <div className="row">
          <div className={`col-12 col-lg-2 ${ourPeopleStyles.tabList}`}>
            <ul>
              {tabs &&
                tabs.map((tab, idx) => (
                  <li key={idx}>
                    <a
                      href="#!"
                      className={`${ourPeopleStyles.dataTab} ${
                        idx === openTab
                          ? ourPeopleStyles.activeTab
                          : ourPeopleStyles.inactiveTab
                      }`}
                      onClick={evt => {
                        evt.preventDefault()
                        setOpenTab(idx)
                        setOpenSubTab(0)
                      }}
                    >
                      <h3>{tab.title}</h3>
                      {idx === openTab && <p>{tab.desc}</p>}
                    </a>
                  </li>
                ))}
            </ul>
          </div>

          <div className={`col-12 col-lg-3 ${ourPeopleStyles.tabList}`}>
            <ul>
              {tabs &&
                tabs[openTab] &&
                tabs[openTab].cols &&
                tabs[openTab].cols.map((tab, idx) => (
                  <li key={idx}>
                    <a
                      href="#!"
                      className={`${ourPeopleStyles.dataTab} ${
                        idx === openSubTab
                          ? ourPeopleStyles.activeTab
                          : ourPeopleStyles.inactiveTab
                      }`}
                      onClick={evt => {
                        evt.preventDefault()
                        setOpenSubTab(idx)
                      }}
                    >
                      <h4>{tab.title}</h4>
                      {idx === openSubTab && <p>{tab.desc}</p>}
                    </a>
                  </li>
                ))}
            </ul>
          </div>

          <div className={`col-12 col-lg-7 ${ourPeopleStyles.subTabcontent}`}>
            {tabs &&
              tabs[openTab] &&
              tabs[openTab].cols &&
              tabs[openTab].cols[openSubTab] && (
                <div
                  className={`row ${ourPeopleStyles.courseInformationContentWrapper}`}
                >
                  <div
                    className={`col-12 ${ourPeopleStyles.courseInformation}`}
                  >
                    <OurPeopleDetails
                      content={tabs[openTab].cols[openSubTab].content}
                      pageContext={props.pageContext}
                      modals={props.modals}
                    />
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OurPeople
